import React, {useEffect, useState} from "react";
import {useCurrentUser} from "~/auth/hooks";
import {Box, Container} from "@mui/material";
import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {CurrentUserProfile} from "~/auth/components/CurrentUserProfile";
import {SignInDialogFullscreen} from "~/auth/components/SignInDialogFullscreen/SignInDialogFullscreen";
import {
    ForbiddenAndUnavailableServiceErrorHandlerProvider
} from "~/components/ErrorHandling/ForbiddenAndUnavailableServiceErrorHandlerProvider";
import {useHistory} from "react-router-dom";


const ProfilePage = () => {
    const history = useHistory();
    const [user, loading] = useCurrentUser();
    const [openSignIn, setOpenSignIn] = useState(!loading && user == null);

    useEffect(() => {
        if (loading) {
            return;
        }
        setOpenSignIn(!loading && user == null);
    }, [user, loading]);

    const handleBackClick = () => {
        history.goBack();
    }

    const handleLogout = () => {
        history.replace("/");
    }

    const handleCloseSignIn = () => {
        history.goBack();
    }

    const handleCompleteSignIn = () => {
        setOpenSignIn(false);
    }

    const appBar = (
        <TitleAppBar onBack={handleBackClick} title="Личный кабинет"/>
    );

    return (
        <ForbiddenAndUnavailableServiceErrorHandlerProvider
            appBar={appBar}
        >
            {appBar}
            <Box marginTop="56px" pt={2}>
                <Container>
                    <CurrentUserProfile onLogout={handleLogout}/>
                </Container>
            </Box>
            <SignInDialogFullscreen open={openSignIn} onClose={handleCloseSignIn} onComplete={handleCompleteSignIn}/>
        </ForbiddenAndUnavailableServiceErrorHandlerProvider>
    )
};


export default ProfilePage;